import { APIGet, StatusCode } from "api/protocols";

const apiVersion = "2024-04";
const adminType = "guest";
const baseUrl = "/" + apiVersion + "/" + adminType + "/tee-sheet/waitlist";

interface IGetWaitlist {
  waitlist_id: string;
}

interface IWaitlistRes {
  status: StatusCode;
  data: any;
}

export async function GetWaitlist(params: IGetWaitlist, useGlobalLoader: boolean): Promise<IWaitlistRes> {
  return await APIGet(baseUrl, params, useGlobalLoader);
}
